import React, { useContext, useEffect, useState } from "react";
import TableLayout from "../table-layout/hoa-table-layout";
import HoaAddViewUpdateComponent from "./hoa-view-update-main-comp";
import SuccessMessage from "../success-message/hoa-success-message";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";

import config from "../../hoa-config";
import datastore from "../../store/hoa-datastore";
import { getChange } from "../../utility/change-log";
import { GlobalContext } from "../../context/hoa-global-context";
import dashboardServices from "../../services/hoa-dashboard-api-service";

export default function HOADashboard() {
	const {
		selectedValues,
		hoa,
		updateSelectedValues,
		updateView,
		view: views,
	} = useContext<any>(GlobalContext);

	const [view, setView] = useState(views !== "view-more-details" ? "list" : "view");
	const [success, setSuccess] = useState(false);
	const [message, setMessage] = useState("");
	const [previousHoa, setPreviousHoa] = useState(JSON.parse(JSON.stringify(selectedValues)));
	const [reloadFutureEffectiveDateLog, setReloadFutureEffectiveDateLog] = useState(false);

	const headers = config.dashboard["HOAs"]?.tableLayout?.title;
	const columns = config.dashboard["HOAs"]?.tableLayout?.columns;
	const filteringTitle = config.dashboard["HOAs"]?.filterComponent?.title;
	const filteringSubTitle = config.dashboard["HOAs"]?.filterComponent?.subTitle;

	const getHOAs = async (numberOfHoas: number, pageNo: number) => {
		const { data } = await dashboardServices.getHoas(
			numberOfHoas,
			pageNo,
			hoa.options,
			datastore.selectedOrganization?.id
		);
		return {
			data: data.hoas,
			count: data.parseCount,
			inactiveHoaCount: data.inactiveHoaCount,
		};
	};

	const getFutureEffectiveDateLog = async (tagTypeId: string) => {
		const { data } = await dashboardServices.getFutureEffectiveDateLog(tagTypeId);
		if (data?.objectId) {
			let changes = getChange(data);
			datastore.changedKeys = Object.keys(changes.changes);
		} else {
			datastore.changedKeys = [];
			console.log("No Effective date");
		}
		setReloadFutureEffectiveDateLog(false);
	};

	useEffect(() => {
		setPreviousHoa(JSON.parse(JSON.stringify(selectedValues)));
	}, [views === "update", selectedValues]);

	useEffect(() => {
		if (reloadFutureEffectiveDateLog && selectedValues?.objectId) {
			getFutureEffectiveDateLog(selectedValues.objectId);
		}
	}, [reloadFutureEffectiveDateLog, selectedValues?.objectId]);

	useEffect(() => {
		if (view == "view") {
			setReloadFutureEffectiveDateLog(true);
		}
	}, [view]);

	useEffect(() => {
		if (views === "add") {
			setMessage("Hoa Created Succesfully");
		} else if (views === "update") {
			setMessage("Hoa Updated Succesfully");
		} else if (views === "back-to-list") {
			setView("list");
			updateView("list");
			return;
		} else if (views === "remove-from-list") {
			setMessage("Hoa Removed Succesfully");
			setView("list");
			updateView("list");
			return;
		} else if (views === "view-more-details") {
			setView("view");
			updateView("view");
			return;
		}
		updateView(view);
	}, [
		view,
		views === "back-to-list",
		views === "remove-from-list",
		views === "view-more-details",
	]);

	return (
		<>
			{view === "list" ? (
				<>
					<FilteringComponenet
						onAddClick={setView}
						title={filteringTitle}
						subTitle={filteringSubTitle}
						tagType={"Hoa"}
					/>
					<TableLayout
						fetchResult={getHOAs}
						headers={headers}
						columns={columns}
						tagType={"Hoa"}
						updateView={setView}
						updateSelectedValues={updateSelectedValues}
					/>
				</>
			) : (
				<HoaAddViewUpdateComponent
					previousHoa={previousHoa}
					setSuccess={setSuccess}
					view={view}
					setView={setView}
					setReloadFutureEffectiveDateLog={setReloadFutureEffectiveDateLog}
				/>
			)}

			<SuccessMessage success={success} setSuccess={setSuccess} message={message} />
		</>
	);
}
